import _ from 'lodash';

//////////////
// DEV MODE //
//////////////
export const DEV_MODE = false;
export const DEV_TYPE: string = 'alpha';
//export const DEV_TYPE: string = 'dienstleister';

export const NAMING_USER_MEDIA = '_userMedia';
export const NAMING_SUSTAINABILITY_FACTOR = '_sustainability';
export const NAMING_LS_IN_MARKTGEBIET = '_active';

// URLs TO APIs
// export const URL_TO_AUTH_API = 'http://localhost:13000';
// export const URL_TO_REFRESH_TOKEN_AT_AUTH_API =
//   'http://localhost:13000/auth/v1/public/token/refresh';
// export const URL_TO_MEDIA_API = 'http://localhost:13004';
// export const URL_TO_MEDIA_SERVER = 'http://localhost:13007';
// export const URL_TO_KEYVAL_SERVER = 'http://localhost:13009';

//Liveserver
const BASE_URL = 'inhaber.cbre.serthoro.io';
export const URL_TO_AUTH_API = `https://api.${BASE_URL}/auth`;
export const URL_TO_REFRESH_TOKEN_AT_AUTH_API = `https://api.${BASE_URL}/auth/v1/public/token/refresh`;
export const URL_TO_MEDIA_API = `https://api.${BASE_URL}/media`;
export const URL_TO_MEDIA_SERVER = `https://media.${BASE_URL}`;
export const URL_TO_LIEGENSCHAFTEN_SERVER = `https://api.${BASE_URL}/property`;
export const URL_TO_KEYVAL_SERVER = `https://api.${BASE_URL}/keyval`;
export const URL_TO_LVEP_SERVER = `https://api.${BASE_URL}/lvep`;
export const URL_TO_DEFAULT_PROPERTY_IMAGE =
  'https://beestate.io/wp-content/uploads/2019/05/beestate_bg_digital.jpg';
export const mediaTokenSecret =
  'HUSn5MmJht06oC1Xj5qNRaGB3SGRGQjIIHkRprNLzgQoqBeSXypII1CSH9FeZtQjBOzUNg74LVvQQePQipJPlhAvqvvnYFUOCbDiHB3yXK0mGwfxZc6OETDSnX9PC6jx';
export const OUTPUT_FILE_HEADLINE = 'CBRE-Rahmenpreisvergabe';

//USER RIGHTS
export const USER_RIGHT_DLREAD: string = 'PERMISSION_DLREAD';
export const USER_RIGHT_DLWRITE_KEYVAL: string = 'PERMISSION_DLWRITEKEYVAL';
export const USER_RIGHT_DLWRITE_MEDIA: string = 'PERMISSION_DLWRITEMEDIA';

export const DEFAULT_FACTOR = 1000;
export const DEFAULT_CALCULATION_MULTIPLIER = 1000;
export const DEFAULT_EXPAND_MAX_DEPT_EP = 7;
export const LV_DEPTH_EP_CATALOG: number = 3; //-1 for deactivate
export const VISIBLE_PROVIDER_IN_ANALYSIS = 5;

export const DL_EP_INPUT_DISABLE_FILTER_ID = 'no-filter';

//placeholder & empty stuff
export const EMPTY_FIELD_PLACEHOLDER = ' — ';

//VALIDATE EMAIL REGEX
export const VALIDATE_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//TOASTS
export const pwChangedToast = 'PwChanged';
export const liegenschaftDeletedToast = 'LiegenschaftDeleted';
export const liegenschaftCreatedToast = 'LiegenschaftCreated';

export const DURATION_NOTIFICATION_SUCCESS_LONG = 4000;
export const DURATION_NOTIFICATION_ERROR_LONG = 4000;

//HEATMAP
export const NUMBER_OF_FACTORS = 5;

export const MIN_VALUE_FACTOR = 0.1;
export const MAX_VALUE_FACTOR = 3;
export const MIN_VALUE_FACTOR_LIEGENSCHAFTEN = 0.7;
export const MAX_VALUE_FACTOR_LIEGENSCHAFTEN = 1.3;
export const MAX_NUMBER_OF_DECIMALS = 3;
export const MIN_NUMBER_OF_DECIMALS = 0;
export const MAX_F =
  _.max([MAX_VALUE_FACTOR, MAX_VALUE_FACTOR_LIEGENSCHAFTEN])! *
  DEFAULT_CALCULATION_MULTIPLIER;

//CALL STATUS
export const SERVER_RESPONSE_PENDING = 'SERVER_RESPONSE_PENDING';
export const SERVER_RESPONSE_ERROR = 'SERVER_RESPONSE_ERROR';
export const SERVER_RESPONSE_SUCCESS = 'SERVER_RESPONSE_SUCCESS';

export const DEFAULT_IMAGE_SIZE = 'MEDIUM';

//ACCEPTED FILE FORMATS
export const ACCEPTED_FORMATS_EXCEL = {
  'application/vnd.ms-excel*': ['.xls', '.xlsx']
};
export const ACCEPTED_FILE_FORMATS = {
  'image/*': ['.jpg', '.jpeg', '.png'],
  'text/*': [
    '.pdf',
    '.json',
    '.xlsx',
    '.xls',
    '.doc',
    '.docx',
    '.ppt',
    '.pptx',
    '.csv',
    '.txt'
  ]
};

export const LIEGENSCHAFT_SORT_NAME = 'Name';
export const LIEGENSCHAFT_SORT_CITY = 'Stadt';
export const LIEGENSCHAFT_SORT_ADDRESS = 'Straße & Hausnummer';
export const LIEGENSCHAFT_SORT_BUILDING_NO = 'Gebäudenummer';

export const DROPDOWN_LIEGENSCHAFT_SORT = [
  LIEGENSCHAFT_SORT_NAME,
  LIEGENSCHAFT_SORT_CITY,
  LIEGENSCHAFT_SORT_ADDRESS,
  LIEGENSCHAFT_SORT_BUILDING_NO
];

export const ALPHA_DL_NOT_IN_MARKETAREA = 'nicht im Marktgebiet';
export const ALPHA_DL_INCOMPLETE_PRICES = 'unvollständig bepreist';
export const ALPHA_DL_NO_PRICE = 'kein Preis';

export const COUNTRIES: COUNTRY[] = [
  {
    id: 'DE',
    country: 'Deutschland',
    regions: [
      { id: 'BW', region: 'Baden-Württemberg' },
      { id: 'BY', region: 'Bayern' },
      { id: 'BE', region: 'Berlin' },
      { id: 'BB', region: 'Brandenburg' },
      { id: 'HB', region: 'Bremen' },
      { id: 'HH', region: 'Hamburg' },
      { id: 'HE', region: 'Hessen' },
      { id: 'MV', region: 'Mecklenburg-Vorpommern' },
      { id: 'NI', region: 'Niedersachsen' },
      { id: 'NW', region: 'Nordrhein-Westfalen' },
      { id: 'RP', region: 'Rheinland-Pfalz' },
      { id: 'SL', region: 'Saarland' },
      { id: 'SN', region: 'Sachsen' },
      { id: 'ST', region: 'Sachsen-Anhalt' },
      { id: 'SH', region: 'Schleswig-Holstein' },
      { id: 'TH', region: 'Thüringen' }
    ]
  }
];

export const LeistungsSlices: LEISTUNGSART[] = [
  {
    id: '101',
    icon: 'icon-company',
    title: 'Objektleitung (6.110)',
    tag: ['objektleitung'],
    sustainability: false
  },
  {
    id: '102',
    icon: 'icon-settings',
    title: 'Bereitstellung von FM-Tools (6.120)',
    tag: ['bereitstellung-fm'],
    sustainability: false
  },
  {
    id: '103',
    icon: 'icon-pruefer',
    title: 'Arbeitssicherheit im FM (6.170)',
    tag: ['arbeitssicherheit-fm'],
    sustainability: false
  },
  {
    id: '104',
    icon: 'icon-energie',
    title: 'Energiemanagement (6.420)',
    tag: ['energiemanagement'],
    sustainability: false
  },
  {
    id: '105',
    icon: 'icon-schedule',
    title: 'Technischer Betrieb (6.310)',
    tag: ['technischer-betrieb'],
    sustainability: false
  },
  {
    id: '106',
    icon: 'icon-warning',
    title: 'Störmanagement',
    tag: ['stoermanagement'],
    sustainability: false
  },
  {
    id: '107',
    icon: 'icon-haushaelter',
    title: 'Hausmeisterdienste',
    tag: ['hausmeisterdienste'],
    sustainability: false
  },
  {
    id: '108',
    icon: 'icon-hammer',
    title: '300 Bauwerk — Baukonstruktionen',
    tag: ['bauwerk-baukonstruktionen'],
    sustainability: false
  },
  {
    id: '109',
    icon: 'icon-water',
    title: '410 Abwasser-, Wasser und Gasanlagen',
    tag: ['abwasser-wasser-gasanlagen'],
    sustainability: false
  },
  {
    id: '110',
    icon: 'icon-van',
    title: '420 Wärmeversorgungsanlagen',
    tag: ['waermeversorgungsanlagen'],
    sustainability: false
  },
  {
    id: '111',
    icon: 'icon-filter',
    title: '430 Lüftungsanlagen',
    tag: ['lueftungsanlagen'],
    sustainability: false
  },
  {
    id: '112',
    icon: 'icon-snow',
    title: '434 Kälteanlagen',
    tag: ['kaelteanlagen'],
    sustainability: false
  },
  {
    id: '113',
    icon: 'icon-flash',
    title: '440 Elektrische Anlagen',
    tag: ['elektrische-anlagen'],
    sustainability: false
  },
  {
    id: '114',
    icon: 'icon-comment',
    title:
      '450 Kommunikations-, sicherheits- und informationstechnische Anlagen',
    tag: ['kommunikations-anlagen'],
    sustainability: false
  },
  {
    id: '115',
    icon: 'icon-elevator',
    title: '460 Förderanlagen',
    tag: ['foerderanlagen'],
    sustainability: false
  },
  {
    id: '116',
    icon: 'icon-agreement',
    title: '470 Nutzungsspezifische und verfahrenstechnische Anlagen',
    tag: ['nutzungsspezifische-anlagen'],
    sustainability: false
  },
  {
    id: '117',
    icon: 'icon-chart',
    title: '480 Gebäudeautomation',
    tag: ['gebaeudeautomation'],
    sustainability: false
  },
  {
    id: '118',
    icon: 'icon-tree',
    title: '550 Einbauten in Außenanlagen',
    tag: ['einbauten-außenanlagen'],
    sustainability: false
  },
  {
    id: '119',
    icon: 'icon-sustainability',
    title: '540 Technische Anlagen in Außenanlagen',
    tag: ['technische-außenanlagen'],
    sustainability: false
  },
  {
    id: '120',
    icon: 'icon-user',
    title: 'Tageskraft',
    tag: ['tageskraft'],
    sustainability: false
  },
  {
    id: '121',
    icon: 'icon-kunststoff',
    title: 'Verbrauchsmaterial',
    tag: ['verbrauchsmaterial'],
    sustainability: false
  },
  {
    id: '122',
    icon: 'icon-reinigung',
    title: 'Unterhaltsreinigung',
    tag: ['unterhaltsreinigung'],
    sustainability: false
  },
  {
    id: '123',
    icon: 'icon-eye',
    title: 'Glas- / Fassadenreinigung',
    tag: ['glas-fassadenreinigung'],
    sustainability: false
  },
  {
    id: '124',
    icon: 'icon-gartenarbeit',
    title: 'Reinigung Aussenanlagen',
    tag: ['reinigung-aussenanlagen'],
    sustainability: false
  },
  {
    id: '125',
    icon: 'icon-inside',
    title: 'Innenbereich',
    tag: ['innenbereich'],
    sustainability: false
  },
  {
    id: '126',
    icon: 'icon-garten',
    title: 'Außenbereich',
    tag: ['aussenbereich'],
    sustainability: false
  },
  {
    id: '127',
    icon: 'icon-giessen',
    title: 'Pflege Aussenanlagen',
    tag: ['pflege-aussenanlagen'],
    sustainability: false
  },
  {
    id: '128',
    icon: 'icon-winter',
    title: 'Winterdienst',
    tag: ['winterdienst'],
    sustainability: false
  },
  {
    id: '129',
    icon: 'icon-schild',
    title: 'Revierdienst',
    tag: ['revierdienst'],
    sustainability: false
  },
  {
    id: '130',
    icon: 'icon-key',
    title: 'Pforten-/Empfangsdienst',
    tag: ['pforten-empfangsdienst'],
    sustainability: false
  },
  {
    id: '131',
    icon: 'icon-lock',
    title: 'Schliessdienst / - Management',
    tag: ['schliessdienst-management'],
    sustainability: false
  }
];

/** Tag-ID → Anzeigetitel (aus den jeweiligen LeistungsSlices). */
export const tags = Object.fromEntries(
  LeistungsSlices.flatMap((slice) =>
    slice.tag.map((tagKey) => [tagKey, slice.title])
  )
) as Record<string, string>;
export type LEISTUNGSART = {
  id: string;
  icon: string;
  title: string;
  tag: string[];
  sustainability: boolean;
};

export type COUNTRY = {
  id: string;
  country: string;
  regions: REGION[];
};

export type REGION = {
  id: string;
  region: string;
};

//CLUSTERVIEW OPTIONAL POSITION
export const prefixInactive = 'inaktivBedarf_';
export const prefixActive = 'aktivBedarf_';
